import {memo} from "react";
import type {CalendarWeek} from "react-native-ui-datepicker";

import {Text} from "../ui/text";

const Weekday = ({weekday}: {weekday: CalendarWeek}) => {
    return (
        <Text className="uppercase" color="blueGray.600">
            {weekday.name.min[0]}
        </Text>
    );
};

export default memo(Weekday);
